import { AdminGuard } from './admin.guard';
import { SuperAdminGuard } from './super-admin.guard';

export { AdminGuard, SuperAdminGuard };

export const guards = [AdminGuard, SuperAdminGuard];
